import { IconLoader2 } from "@tabler/icons-react";
import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";
import type { ReactNode } from "react";

import { cn } from "@roko/ui/lib/utils";

const spinnerVariants = cva("flex-row items-center justify-center", {
  variants: {
    show: {
      true: "flex",
      false: "hidden",
    },
  },
  defaultVariants: {
    show: true,
  },
});

const loaderVariants = cva("animate-spin text-primary", {
  variants: {
    size: {
      small: "size-6",
      medium: "size-8",
      large: "size-12",
    },
  },
  defaultVariants: {
    size: "medium",
  },
});

interface ISpinnerContentProps
  extends
    VariantProps<typeof spinnerVariants>,
    VariantProps<typeof loaderVariants> {
  className?: string;
  children?: ReactNode;
}

export const Spinner = ({
  size,
  show,
  children,
  className,
}: ISpinnerContentProps) => {
  return (
    <span className={spinnerVariants({ show })}>
      <IconLoader2 className={cn(loaderVariants({ size }), className)} />
      {children}
    </span>
  );
};
